export const getState = (state)=>state.capacityPerClass
